import axios from "axios";
import config from "../../utils/config/config";
import { fileToBase64, getFileUrl, getFileUsingUrl } from "../FilesService";
import { Headers } from "../../utils/config/configHelpers";

const baseUrl = config.gRPCURL;

const configHeaders = () => ({
    headers: Headers(),
    timeout: 100000,
});


const uploadLargeFile = async (fileInfo) => {
    const base64Str = await fileToBase64(fileInfo.file);
    const payload = {
        ...fileInfo,
        file: base64Str,
    };

    console.log("uploadLargeFile", payload);

    return axios.post(
        `${baseUrl}/grpc/file.FileService/UploadFile`,
        payload,
        configHeaders()
    );
};

const uploadFile = async (folder, fileName, fileData, selectedDomain) => {
    const base64Str = await fileToBase64(fileData);

    const payloadData = {
        appType: selectedDomain,
        base64File: base64Str,
        domain: selectedDomain,
        fileName,
        fileScope: null,
        generateThumbnail: true,
        platform: "web", 
        scopeId: folder,
        selectedDomain,
        userDomain: selectedDomain,
    };

    return axios.post(
        `${baseUrl}/grpc/file.FileService/UploadFileBase64`,
        payloadData,
        configHeaders()
    );
};


const uploadProfilePhoto = (userId, fileData, selectedDomain) => {
    return uploadFile("profile-pics", userId, fileData, selectedDomain);
};

export function getProfilePhoto(fileName) {
	return getFileUsingUrl(getFileUrl("profile-pics", fileName));
}

export const FileApiServices = {
    uploadLargeFile,
    uploadProfilePhoto,
    uploadFile,
    getProfilePhoto
};